/** @im/im-theme v2.0.994 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _imTheme = require("./ImThemeProvider/imTheme.types");
Object.keys(_imTheme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _imTheme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _imTheme[key];
    }
  });
});
var _ImThemeProviderZenith = require("./ImThemeProvider/ImThemeProviderZenith");
Object.keys(_ImThemeProviderZenith).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ImThemeProviderZenith[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ImThemeProviderZenith[key];
    }
  });
});
var _useImTheme = require("./ImThemeProvider/useImTheme");
Object.keys(_useImTheme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useImTheme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useImTheme[key];
    }
  });
});
var _themeZenith = require("./themeZenith");
Object.keys(_themeZenith).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _themeZenith[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _themeZenith[key];
    }
  });
});
var _ImThemeProvider = require("./ImThemeProvider/ImThemeProvider");
Object.keys(_ImThemeProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ImThemeProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ImThemeProvider[key];
    }
  });
});
var _theme = require("./theme");
Object.keys(_theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _theme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _theme[key];
    }
  });
});